import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export default class InventoryStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'InventoryStore',
			properties: [
				'products',
				'stocks',
				'stockAnalysis',
				'selectedProduct',
				'selectedStock',
				'splitPayments',
				'rates',
				'eurPrice',
				'gbpPrice',
			],
		});
	}

	products = [];
	stocks = [];
	stockAnalysis = {};
	selectedProduct = {};
	selectedStock = {};
  splitPayments = [];
	rates = [];
	eurPrice = 0;
	gbpPrice = 0;

	reset = () => {
		this.products = [];
		this.stocks = [];
		this.stockAnalysis = {};
		this.selectedProduct = {};
		this.selectedStock = {};
		this.splitPayments = [];
		this.rates = [];
	};

	setSplitPayments = async state => {
        runInAction(async () => {
            this.splitPayments = state;
        });
    };

	setProducts = async state => {
		runInAction(async () => {
			this.products = state;
		});
	};
	setStocks = async state => {
		runInAction(async () => {
			this.stocks = state;
		});
	};
	setStockAnalysis = async state => {
		runInAction(async () => {
			this.stockAnalysis = state;
		});
	};
	setSelectedProduct = async state => {
		runInAction(async () => {
			this.selectedProduct = state;
		});
	};
	setSelectedStock = async state => {
		runInAction(async () => {
			this.selectedStock = state;
		});
	};

	setRates = async state => {
		runInAction(async () => {
			this.rates = state;
		});
	}

	setEurPrice = async state => {
		runInAction(async () => {
			this.eurPrice = state;
		});
	}

	setGbpPrice = async state => {
		runInAction(async () => {
			this.gbpPrice = state;
		});
	}
}
